import {useParams} from "react-router-dom";
import React, {useEffect} from "react";
import {ViewMode} from "../common/ViewMode";
import {useAppDispatch, useAppSelector} from "../../feature/tools";
import {Status} from "../../feature/project/status";
import {fetchStories} from "../../feature/project/storySlice";
import {List} from "../common/ListItems";

export const Stories = (props: { viewMode: ViewMode }) => {
    const dispatch = useAppDispatch()
    const {projectId} = useParams();
    const stories = useAppSelector(state => state.stories.stories);
    const needRefresh = useAppSelector(state => state.stories.needRefresh);

    useEffect(() => {
        if (projectId && needRefresh) {
            dispatch(fetchStories(parseInt(projectId)))
        }
    }, [projectId, needRefresh, dispatch])


    return (
        <List
            items={stories}
            viewMode={props.viewMode}
            path={(id) => `/projects/${projectId}/stories/${id}`}
        />
    )
}